import type { ApiRuntime } from './apiRuntime';

/**
 * How to find the runtime that belongs to "now": the request being rendered on the server, the one
 * runtime of the app in the browser. Each app registers this once, where it starts (the frontend in
 * its router module, the embed app in its entry); a later registration replaces the earlier one so
 * a hot module reload keeps working.
 *
 * Only labels may be read through it: the account on a log line. A wrong or missing answer costs a
 * less useful log line and nothing else. Credentials never come from here; they travel with the
 * QueryClient that runs the call (see binding.ts), and query keys are scoped by that same client
 * (see queryClient.ts), so no request-bound state is read during a render.
 */
export type RuntimeResolver = () => ApiRuntime | undefined;

let resolveRuntime: RuntimeResolver | undefined;

export function registerRuntimeResolver(resolver: RuntimeResolver): void {
    resolveRuntime = resolver;
}

/** Never throws: no runtime simply means no enrichment. */
export function tryCurrentRuntime(): ApiRuntime | undefined {
    try {
        return resolveRuntime?.();
    } catch {
        return undefined;
    }
}
